import React, { useState, useEffect, useRef } from 'react';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import InputText from '../../Shared/TextInput/TextInput';
import PlaneLoader from './PlaneLoader';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Config from '../../../Config';
import OtpInput from 'react-otp-input';
import { saleOTPSteps, customerTypeEnum } from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import {
  changePhoneInputHandler,
  onBlurHandler,
  setOtpVerifyCode,
  setSaleOtpStep,
  removeOtpData,
  hideOtpErrorMessage,
  saveToHistory,
  setShadowCCUpdateMode,
  setShadowFormData,
  UpdateEmailOfCustomer,
  setIsSelectingAccountBusinessIndividual,
  setOtpPhone,
  setBuyPackageInSplit,
  setSwitchingAccount,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import EpiContext from '@episerver/spa-core/Spa';
import { prepareUrl, buildUrlAndOpenWindow } from '../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import PopUp from '../../Shared/Popup/PopUp';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnRightSideText from '../../Shared/Buttons/BtnRightSideText';
import BillingAddressRenderer from '../CellcomAbroadLobbyBlock/separatedSale/outsideComponents/BillingAddressRenderer/billingAddressRenderer';
import PaymentRenderer from '../CellcomAbroadLobbyBlock/separatedSale/outsideComponents/PaymentRenderer/paymentRenderer';
import PaperPlane from '../CellcomAbroadLobbyBlock/separatedSale/SVG/PaperPlane';
import Phone from '../CellcomAbroadLobbyBlock/separatedSale/SVG/Phone';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import ErrorIcon from '../CellcomAbroadLobbyBlock/separatedSale/SVG/ErrorIcon';
import SuccessIcon from '../CellcomAbroadLobbyBlock/separatedSale/SVG/SuccessIcon';
import { gaChangeAccountOnTicketPage, gaTicketPhoneValueIsNotValid, gaTicketOtpStep } from './gaReports';
import { resetAuth, resetLoginData, setOtpError, setRestrictedCodeError } from '../../../utilities/authentication/authenticationSlice';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import { setSelfcareSubscriber } from '../../Page/SelfCarePage/SelfCareSlice'
import FamilyBundleSection from './FamilyBundleSection';

function BottomBlock(props) {
  const ref = useRef();
  const mailSuccess = 'Success',
    mailError = 'Error',
    mailUpdate = 'Update';
  const [showUpdateEmail, setUpdateEmail] = useState(false);
  const [newMailDetails, setNewMailDetails] = useState(props.data.shadowForm?.customerEmail);
  const [showNewMailError, setNewMailError] = useState(null);
  const [mailUpdateStatus, setUpdateStatus] = useState(mailUpdate);

  useEffect(() => {
    if (props.data.otpData.isOTPValidated || props.data.epiStyleInitializationData.businessIndividualLobby) {
      props.setSaleOtpStep(saleOTPSteps.AFTER_INPUT);
    } else {
      if (!isMobile && props.data.saleOTPStep == saleOTPSteps.MOBILE_INPUT) {
        ref.current?.focus();
      }
    }
  }, []);

  useEffect(() => {
    if (props.data.otpData.saleOTPStep == saleOTPSteps.OTP) {
      gaTicketOtpStep(props.businessOrPrivate);
    } else if (props.data.otpData.saleOTPStep == saleOTPSteps.AFTER_INPUT) {
      props.saveToHistory();
    }
  }, [props.data.otpData.saleOTPStep]);

  useEffect(() => {
    if (props.data.otpData.saleOTPStep == saleOTPSteps.MOBILE_INPUT && props.data.otpPhoneForm.errors.phone) {
      gaTicketPhoneValueIsNotValid(props.businessOrPrivate);
    }
  }, [props.data.otpPhoneForm.errors.phone]);

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleChangeOTPCode(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  function handleChangeOTPCode(otp) {
    props.setOtpError(null);
    props.setRestrictedCodeError(null);
    if (props.data.otpData.showWrongOtpCodeMessage) {
      props.hideOtpErrorMessage();
    }

    props.setOtpVerifyCode({ verifyCode: otp });
  }

  const changeAccount = () => {
    gaChangeAccountOnTicketPage();
    let params = {
      isSelecting: true,
      removeSelectedAbroadPackage: false,
    };
    props.setIsSelectingAccountBusinessIndividual(params);
    props.setSwitchingAccount(true);
    props.setBuyPackageInSplit(null);
    props.context.navigateTo(props.data.businessIndividualData.selfCareBlockUrl);
  };

  const openAgreementPDF = () => {
    switch (props.businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.eventParams,
          );
        }
        break;
      default:
        break;
    }
    prepareUrl(props.data.selectedAbroadPackage?.policiesEpi, EpiContext);
  };

  const disconnectFromOtp = async () => {
    // await props.resetAuth();
    props.resetLoginData();
    props.removeOtpData();
    props.saveToHistory();
  };

  const mailValidation = (mailAddress) => {
    const regMail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regMail.test(String(mailAddress).toLowerCase());
  };

  const determineBottomControls = () => {
    if (!props.data.epiStyleInitializationData.businessIndividualLobby && props.data.otpData.validatedCostumerData?.isSeparatedSale) {
      let popupContent = null;

      switch (mailUpdateStatus) {
        case mailUpdate:
          popupContent = (
            <>
              <TextInput
                placeholder='כתובת מייל'
                name='mailAddress'
                value={newMailDetails}
                onChange={(e) => {
                  setNewMailDetails(e.target.value);
                  setNewMailError(null);
                }}
                error={showNewMailError}
              />
              <BtnRightSideText
                text='עדכון'
                isBusiness={true}
                isGreyBg={mailValidation(newMailDetails) ? false : true}
                onclick={(e) => {
                  e.preventDefault();
                  gaEvent(
                    gaParams.SEPARATED_UPDATEMAILSEND_CLICK.category,
                    gaParams.SEPARATED_UPDATEMAILSEND_CLICK.eventType,
                    gaParams.SEPARATED_UPDATEMAILSEND_CLICK.eventParams,
                  );
                  if (mailValidation(newMailDetails)) {
                    if (
                      props.data.otpData.validatedCostumerData?.shadowData?.ban &&
                      props.data.otpData.validatedCostumerData?.shadowData?.ban != '0' &&
                      props.data.otpData.validatedCostumerData?.shadowData?.ban != '-1' &&
                      props.data.otpData.validatedCostumerData?.shadowData?.status != 'N'
                    ) {
                      props
                        .UpdateEmailOfCustomer({
                          ban: props.data.otpData.validatedCostumerData?.shadowData?.ban,
                          email: newMailDetails,
                          subscriber: props.data.otpData.otpPhone,
                        })
                        .then((res) => {
                          if (res.payload.Body.wasSuccessful) {
                            setUpdateStatus(mailSuccess);
                            setTimeout(() => {
                              setUpdateEmail(false);
                              setUpdateStatus(mailUpdate);
                            }, 2000);
                          } else {
                            setUpdateStatus(mailError);
                          }
                        });
                    } else {
                      const shadowState = { ...props.data.shadowForm };
                      props.setShadowFormData({
                        ...shadowState,
                        customerEmail: newMailDetails,
                      });
                      setUpdateEmail(false);
                      setUpdateStatus(mailUpdate);
                    }
                  } else {
                    setNewMailError('נראה שיש כאן טעות, כל האותיות במקום?');
                    gaEvent(
                      gaParams.SEPARATED_INVALIDMAILINUPDATE_SHOW.category,
                      gaParams.SEPARATED_INVALIDMAILINUPDATE_SHOW.eventType,
                      gaParams.SEPARATED_INVALIDMAILINUPDATE_SHOW.eventParams,
                    );
                  }
                }}
              />
              <BtnWhite
                text='ביטול'
                onclick={() => {
                  gaEvent(
                    gaParams.SEPARATED_UPDATEMAILCANCEL_CLICK.category,
                    gaParams.SEPARATED_UPDATEMAILCANCEL_CLICK.eventType,
                    gaParams.SEPARATED_UPDATEMAILCANCEL_CLICK.eventParams,
                  );
                  setUpdateEmail(false);
                }}
              />
            </>
          );
          break;
        case mailError:
          gaEvent(
            gaParams.SEPARATED_MAILUPDATEFAILURE_SHOW.category,
            gaParams.SEPARATED_MAILUPDATEFAILURE_SHOW.eventType,
            gaParams.SEPARATED_MAILUPDATEFAILURE_SHOW.eventParams,
          );
          popupContent = (
            <>
              <div className='mainHeading p-0 m-0'>רגע, משהו לא הסתדר</div>
              <div className='plane'>
                <ErrorIcon />
              </div>
              <div className='popupExplanation'>
                לא הצלחנו לעדכן כתובת מייל,
                <br />
                אפשר לנסות שוב בעוד מספר דקות
              </div>
              <BtnRightSideText
                isBusiness={true}
                text='סיום'
                onclick={() => {
                  setUpdateEmail(false);
                  setUpdateStatus(mailUpdate);
                }}
              />
            </>
          );
          break;
        case mailSuccess:
          gaEvent(
            gaParams.SEPARATED_SUCCESSFULUPDATEMAIL_SHOW.category,
            gaParams.SEPARATED_SUCCESSFULUPDATEMAIL_SHOW.eventType,
            gaParams.SEPARATED_SUCCESSFULUPDATEMAIL_SHOW.eventParams,
          );
          popupContent = (
            <>
              <div className='mainHeading p-0 m-0'>זהו, עדכנו את כתובת המייל שלך</div>
              <div className='plane'>
                <SuccessIcon />
              </div>
            </>
          );
          break;
      }
      const existingClient =
        props.data.otpData.validatedCostumerData?.shadowData?.ban &&
        props.data.otpData.validatedCostumerData?.shadowData?.ban != '0' &&
        props.data.otpData.validatedCostumerData?.shadowData?.ban != '-1' &&
        props.data.otpData.validatedCostumerData?.shadowData?.status != 'N' &&
        props.data.shadowForm?.customerEmail == '';
      return (
        <>
          <PaymentRenderer
            existingClient={existingClient}
            paymentMethod={props.data?.shadowClientBillData?.paymentType}
            paymentData={props.data.shadowClientBillData?.paymentData}
            Credit4Digits={props.data.shadowCG?.Credit4Digits}
            shouldUpdate={props.data.shadowClientBillData?.shouldUpdate}
            showErrorMessage={props.paymentErrorMessage}
            ccUpdated={props.data.shadowUpdatedCC}
            onclick={() => {
              gaEvent(
                gaParams.SEPARATED_UPDATEPAYMENTOPENTICKET_CLICK.category,
                gaParams.SEPARATED_UPDATEPAYMENTOPENTICKET_CLICK.eventType,
                gaParams.SEPARATED_UPDATEPAYMENTOPENTICKET_CLICK.eventParams,
              );
              props.setShadowCCUpdateMode(true);
              props.context.navigateTo(props.data.epiStyleInitializationData.urlToSeparatedSale);
            }}
          />
          <BillingAddressRenderer
            existingClient={existingClient}
            billingType={props.data?.shadowClientBillData?.billingType}
            billingData={props.data.shadowClientBillData?.billingAddressData}
            formEmail={props.data.shadowForm?.customerEmail}
            onclick={() => {
              gaEvent(
                gaParams.SEPARATED_UPDATEMAILOPENTICKET_CLICK.category,
                gaParams.SEPARATED_UPDATEMAILOPENTICKET_CLICK.eventType,
                gaParams.SEPARATED_UPDATEMAILOPENTICKET_CLICK.eventParams,
              );
              setUpdateEmail(true);
              gaEvent(
                gaParams.SEPARATED_MAILUPDATE_SHOW.category,
                gaParams.SEPARATED_MAILUPDATE_SHOW.eventType,
                gaParams.SEPARATED_MAILUPDATE_SHOW.eventParams,
              );
            }}
          />
          <PopUp
            className='mailUpdatePopUp_SeparatedSale'
            showPopUp={showUpdateEmail}
            onClose={() => {
              setUpdateEmail(false);
              setUpdateStatus(mailUpdate);
            }}>
            {props.data.isLoading ? (
              <div className='loader-wrapper'>
                <PlaneLoader />
              </div>
            ) : null}
            {popupContent}
          </PopUp>
        </>
      );
    }
    return (
      props.data.selectedAbroadPackage?.isFamilyBundle ? (
        <FamilyBundleSection setShowMessage={props.setShowMessage} setErrorMessageText={props.setErrorMessageText} setSaleOtpStep={props.setSaleOtpStep} />
      ) : (
        <div
          className={`${props.authentication?.loginData?.isFullAuthenticated ? 'd-flex flex-wrap align-items-center' : ''
            } bottom-where-flight-to-text`}>
          <span
            className={`${props.authentication?.loginData?.isFullAuthenticated && props.data.relatedPhoneNumbers?.length > 1 ? 'pb-10' : ''
              }`}>
            הנייד שעליו נתקין את החבילה
          </span>
          {props.data.epiStyleInitializationData.businessIndividualLobby ? (
            <span className='bold mx-1'>{props.data.businessIndividualData.selectedAccountNumber}</span>
          ) : (
            getPhoneNumberHtml()
          )}
          {((!props.data.isJETAuthentication &&
            !props.authentication.loginData.isFullAuthenticated &&
            props.data.relatedPhoneNumbers?.length != 1) ||
            props.data.epiStyleInitializationData.businessIndividualLobby) && (
              <div
                className='bottom-pink-text-click'
                onClick={() => (props.data.epiStyleInitializationData.businessIndividualLobby ? changeAccount() : disconnectFromOtp())}>
                שינוי
              </div>
            )}
        </div>
      )
    );
  };
  const getSelectPlaceHolder = () => {
    if (
      props.data.otpData.otpPhone &&
      props.data.relatedPhoneNumbers.length > 0 &&
      props.data.relatedPhoneNumbers.includes(props.data.otpData.otpPhone)
    ) {
      return props.data.otpData.otpPhone;
    } else {
      return 'בחר מנוי';
    }
  };

  const getPhoneNumberHtml = () => {
    if (
      ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) && props.data.relatedPhoneNumbers?.length > 1) ||
      (props.data.relatedPhoneNumbers?.length == 1 &&
        !props.data.relatedPhoneNumbers.includes(props.authentication.loginData.userDetails.contactNumber))
    ) {
      return (
        <ReactSelect
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          placeholder={getSelectPlaceHolder()}
          value={props.data.relatedPhoneNumbers.filter((option) => option == props.data.otpData.otpPhone)}
          name='selected'
          options={props.data.relatedPhoneNumbers}
          onChange={(phone) => setAndValidatePhone(phone)}
        />
      );
    } else {
      return <span className='bold mx-1'>{props.data.otpData.otpPhone}</span>;
    }
  };

  const setAndValidatePhone = (phone) => {
    props.setOtpPhone(phone);
    props.submitValidateCustomerType(phone);
    props.setSelfcareSubscriber(phone);
  };

  const showBusinessTerms = async () => {
    let socCode = props.data.selectedAbroadPackage.socCode;
    const url = `${Config.termsUrl}?socCode=${socCode}`;
    let win = window.open(url, '_blank');
    win.focus();
  };

  const termOfUse = () => {
    if (props.data.epiStyleInitializationData.businessIndividualLobby && !props.data.selectedAbroadPackage.blockId) {
      return (
        <div className='bottom-confirm-line'>אני מאשר כי ידועים לי התנאים המלאים של החבילה המפורטים בהסכם המכר של {window.Config.brand_Name_HE} עם החברה </div>
      );
    }
    return (
      <div className='bottom-confirm-line'>
        {props.data.otpData.validatedCostumerData?.isSeparatedSale ? 'אישור' : 'קראתי ואישרתי את'}{' '}
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_PACKAGETERMSTICKET_CLICK.category,
                gaParams.SEPARATED_PACKAGETERMSTICKET_CLICK.eventType,
                gaParams.SEPARATED_PACKAGETERMSTICKET_CLICK.eventParams,
              );
            }

            props.data.selectedAbroadPackage?.policiesEpi ? openAgreementPDF() : showBusinessTerms();
          }}>
          תנאי החבילה{' '}
        </span>
      </div>
    );
  };

  function renderStep(step) {
    switch (step) {
      case saleOTPSteps.MOBILE_INPUT:
        return (
          <>
            <div className='bottom-where-flight-to-header'>מי טס?</div>
            <div className='phone-input-container'>
              <InputText
                className='otp-phone-input'
                ref={ref}
                name='phone'
                type='tel'
                pattern='[0-9]*'
                id='phone'
                maxLength='10'
                autoComplete='off'
                placeholder={props.placeholder ?? 'הנייד שעליו נתקין את החבילה'}
                required='required'
                value={props.data.otpPhoneForm.phone}
                error={props.data.otpPhoneForm.errors.phone}
                onChange={(e) => props.changePhoneInputHandler({ target: e.target, form: props.data.otpPhoneForm })}
              />
            </div>
            {(props.authentication.formError.otpCodeError != null ||  props.data.otpCodeForm.valid == "") && (
              <div className='error-container text-center'>
                <span>{props.authentication.formError.otpCodeError || props.data.otpCodeForm.errors.verifyCode}</span>
              </div>
            )}
          </>
        );
      case saleOTPSteps.OTP:
        return (
          <>
            <div className='bottom-where-flight-to-header' style={{ marginBottom: 'unset' }}>
              מי טס?
            </div>
            <div className='bottom-where-flight-to-text' style={{ alignSelf: 'center', marginBottom: '7px', fontSize: '15px' }}>
              הקלידו את הקוד ששלחנו לנייד
            </div>
            <div className='otp-verify-code'>
              <OtpInput
                shouldAutoFocus={true}
                value={props.data.otpCodeForm.verifyCode}
                onChange={handleChangeOTPCode}
                numInputs={6}
                isInputNum={true}
                separator={<span className='inputSeparator'></span>}
                inputStyle={`input-design`}
                inputType="tel"
                containerStyle={`mainDivInside`}
                name="otp"
                renderInput={(inputProps, index) => (
                  <input {...inputProps} key={index}
                      autoComplete="one-time-code"
                      inputMode="numeric"
                      pattern="[0-9]*"
                  />
                )}
              />
            </div>
            {(props.authentication.formError.otpCodeError != null ||  props.data.otpCodeForm.valid == "") && (
              <div className='error-container text-center'>
                <span>{props.authentication.formError.otpCodeError || props.data.otpCodeForm.errors.verifyCode}</span>
              </div>
            )}
          </>
        );
      case saleOTPSteps.LOADER:
        return <PlaneLoader text={'רק רגע, בודקים את המספר'} />;
      case saleOTPSteps.AFTER_INPUT:
        return (
          <>
            <div className='bottom-where-flight-to-header'>
              {props.data.selectedAbroadPackage?.isFamilyBundle 
                ? '' 
                : props.data.otpData.validatedCostumerData?.isSeparatedSale ? 'איך נשלם' : 'מי טס'}
              {!props.data.selectedAbroadPackage?.isFamilyBundle && '?'}
            </div>
            {determineBottomControls()}
            <div className='bottom-where-flight-to-text'>
              <div className='bottom-checkbox'>
                <CheckBox
                  id='agreementCheckbox'
                  onCheck={() => props.onCheck()}
                  onUncheck={() => props.onUncheck()}
                  checked={props.checkBoxChecked}
                  label={''}
                />
              </div>
              {termOfUse()}
            </div>

            {props.NeedToSignCollaborationApproval && props.businessOrPrivate == 'Private' && (
              <div className='bottom-where-flight-to-text'>
                <div className='bottom-checkbox'>
                  <CheckBox
                    id='collaborateCheckbox'
                    onCheck={() => props.onCheckCollaboration()}
                    onUncheck={() => props.onUncheckCollaboration()}
                    checked={props.checkBoxCollaborationChecked}
                    label={<ThirdParty />}
                  />
                </div>
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  }

  return <div className='bottom-where-flight-to-box'>{renderStep(props.data.otpData.saleOTPStep)}</div>;
}

const mapStateToProps = (state) => ({
  data: state.cellcomAbroad,
  paymentDetails: state.PaymentCG,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  changePhoneInputHandler,
  onBlurHandler,
  setOtpVerifyCode,
  setBuyPackageInSplit,
  setSaleOtpStep,
  removeOtpData,
  setSwitchingAccount,
  resetAuth,
  resetLoginData,
  hideOtpErrorMessage,
  saveToHistory,
  setShadowCCUpdateMode,
  setShadowFormData,
  UpdateEmailOfCustomer,
  setIsSelectingAccountBusinessIndividual,
  setSelfcareSubscriber,
  setOtpPhone,
  setOtpError,
  setRestrictedCodeError
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomBlock);

